import React from "react";
import LeadsContent from "../components/leads/leads-content";

const MyLeads = () => {
  return <LeadsContent showOnlyMine pageTitle="My Leads" />;
};

export default MyLeads;
